var tr = {};
module['exports'] = tr;
tr.title = "Turkish";
tr.address = require("./address");
tr.internet = require("./internet");
tr.lorem = require("./lorem");
tr.phone_number = require("./phone_number");
tr.cell_phone = require("./cell_phone");
tr.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/index.js
// module id = 1169
// module chunks = 0